import * as React from "react"
// import TransitionLink from 'gatsby-plugin-transition-link'
import AniLink from "gatsby-plugin-transition-link/AniLink"
import * as bottomNavStyles from './bottom-nav.module.css'
import PjmLogo from '../svg/pjm-logo.inline.svg';

const BottomNav = (props) => {
    const colors = {
        pink: '#e51087',
        orange: '#eb9547',
        green: '#8dbb41',
        yellow: '#f3c22d',
        lightblue: '#6ebfdf',
        blue: '#4e91d6',
        darkblue: '#003a5d',
    }

    return (
        <footer className={bottomNavStyles.footer}>
            <div className="container pt-5 pb-5">
                <div className="row">
                    <div className="col-xs-12">
                        <div className={bottomNavStyles.linkWrap}>
                            <AniLink 
                                paintDrip 
                                hex={colors[props.nextColor]} 
                                direction="left" 
                                to={props.nextLink} 
                                className={`${bottomNavStyles[props.nextColor]} ${bottomNavStyles.navLink} ${bottomNavStyles.arrow} ${bottomNavStyles.nextLink} next-link transition-link h4`}>
                                {props.nextLinkTitle}
                            </AniLink>
                            <AniLink 
                                paintDrip 
                                hex={colors[props.prevColor]} 
                                direction="left" 
                                to={props.prevLink} 
                                className={`${bottomNavStyles[props.prevColor]} ${bottomNavStyles.navLink} ${bottomNavStyles.arrow} ${bottomNavStyles.prevLink} transition-link h4`}>
                                {props.prevLinkTitle}
                            </AniLink>
                        </div>
                    </div>
                </div>
            </div>
            <div className={bottomNavStyles.borderTop}>
                <div className="container pb-5">
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <div className={bottomNavStyles.pjmPosition}>
                                <div className={bottomNavStyles.logoWrap}>
                                    <PjmLogo />
                                </div>
                                <span>Working to Perfect the Flow of Energy</span>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <div className={bottomNavStyles.footerRight}>
                                <div>For information, please contact:  1 (866) 400-8980 • <a className={bottomNavStyles.addressLink} href="https://www.pjm.com/" target="_blank">www.pjm.com</a></div>
                                <div>“PJM” is a registered trademark of PJM Interconnection, L.L.C.</div>
                                <div>PJM ©2021 All rights reserved</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default BottomNav
